import { WifiOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Full-screen notice for an offline cold start without a stored session / cached data. Retries on its own. */
export function OfflineScreen() {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-background p-6 text-center">
      <div className="flex size-16 items-center justify-center rounded-2xl bg-muted text-muted-foreground">
        <WifiOff className="size-8" />
      </div>
      <h1 className="text-xl font-extrabold tracking-tight text-foreground">{t('offline.screenTitle')}</h1>
      <p className="max-w-sm text-sm text-muted-foreground">{t('offline.screenDesc')}</p>
    </div>
  );
}
